import { useEffect, useState } from 'react';
import Table, { Column } from '../common/table';
import { useTranslation } from 'react-i18next';
import FleetsService from '../../services/fleets.services';
import { formatToShortCst } from '../../utils/formatToShortCst';
import FleetModal from './fleets.modal';

export default function FleetsPage() {
  const [rows, setRows] = useState<any[]>([]);
  const [fleetModalOpen, setFleetModalOpen] = useState(false);
  const [selectedFleetId, setSelectedFleetId] = useState<string | null>(null);
  const { t } = useTranslation();

  const columns: Column<any>[] = [
    {
      renderHeader: (i: number) => (
        <th
          key={i}
          className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
          scope="col"
        >
          {t('fleets.name')}
        </th>
      ),
      renderRow: (row, _rowI, colI) => (
        <td key={colI} className="px-6 py-2 text-left text-xs text-gray-500">
          {row.name}
        </td>
      ),
    },
    {
      renderHeader: (i: number) => (
        <th
          key={i}
          className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
          scope="col"
        >
          {t('fleets.type')}
        </th>
      ),
      renderRow: (row, _rowI, colI) => (
        <td key={colI} className="px-6 py-2 text-left text-xs text-gray-500">
          {row.type}
        </td>
      ),
    },
    {
      renderHeader: (i: number) => (
        <th
          key={i}
          className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
          scope="col"
        >
          {t('fleets.numberOfDevices')}
        </th>
      ),
      renderRow: (row, _rowI, colI) => (
        <td key={colI} className="px-6 py-2 text-left text-xs text-gray-500">
          {row.numberOfDevices}
        </td>
      ),
    },
    {
      renderHeader: (i: number) => (
        <th
          key={i}
          className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
          scope="col"
        >
          {t('fleets.createdAt')}
        </th>
      ),
      renderRow: (row, _rowI, colI) => (
        <td key={colI} className="px-6 py-2 text-left text-xs text-gray-500">
          {formatToShortCst(row.createdAt)}
        </td>
      ),
    },
  ];

  const fetchData = async () => {
    const response = await FleetsService.getFleets();
    const data = await response.json();
    setRows(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRowClick = (fleetId: string) => {
    setSelectedFleetId(fleetId);
    setFleetModalOpen(true);
  };

  const handleAdd = () => {
    setSelectedFleetId(null);
    setFleetModalOpen(true);
  };

  return (
    <>
  <FleetModal setOpen={setFleetModalOpen} open={fleetModalOpen} rows={rows} onSave={fetchData} selectedFleetId={selectedFleetId}></FleetModal>

      <Table
        columns={columns}
        rows={rows}
        title={t('fleets.title')}
        showAddButton={true}
        onAdd={handleAdd}
        currentPage={1}
        pageSize={1}
        totalRows={1}
        onRowClick={(row) => handleRowClick(row._id)}
      />
    </>
  );
}
